export function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return decodeURIComponent(r[2])
  }
  return null
}

export function isJiyun() {
  var str1 = navigator.appVersion
  var str2 = navigator.userAgent
  var str = 'pdmiryun'
  if (str1.indexOf(str) > -1 || str2.indexOf(str) > -1) {
    return true
  } else {
    return false
  }
}

export function getFileType(file) {
  var filename = file
  var index1 = filename.lastIndexOf('.')
  var index2 = filename.length
  return filename.substring(index1 + 1, index2)
}
